﻿function toggleTree(e: kendo.ui.ButtonClickEvent, treeList: kendo.ui.TreeList) {
    const isExpanded = treeList.options.dataSource.schema.model.expanded;

    treeList.tbody.find('tr.k-treelist-group').each((_, row) => {
        isExpanded ? treeList.collapse(row) : treeList.expand(row);
    });

    treeList.options.dataSource.schema.model.expanded = !isExpanded;
    e.event.target.textContent = isExpanded ? 'Развернуть' : 'Свернуть';
}

function getCheckedItems(tree: kendo.ui.TreeView) {
    return getCheckedNodes(tree.dataSource.view());
}

function fixTreeView(controlName: string) {
    $(`#${controlName} .k-icon`).addClass('k-icon-fix');
    $(`#${controlName} .k-checkbox-label`).addClass('k-checkbox-label-fix');
    $(`#${controlName} .k-in`).addClass('k-in-fix');
    $(`#${controlName} .k-checkbox-wrapper`).addClass('k-checkbox-wrapper-fix');

    const treeView = $(`#${controlName}`).data('kendoTreeView');

    if (treeView) {
        const items = treeView.dataSource.view();
        fixNodesStyle(treeView, items);
    }
}

function getCheckedNodes(nodes: kendo.data.ObservableArray) {
    let node: kendo.data.CheckedNode;
    let childCheckedNodes: kendo.data.CheckedNode[];
    let checkedNodes: kendo.data.CheckedNode[] = [];

    for (let i = 0; i < nodes.length; i++) {
        node = nodes[i];
        if (node.checked) {
            checkedNodes.push(node);
        }

        if (node.hasChildren) {
            childCheckedNodes = getCheckedNodes(node.children.view());
            if (childCheckedNodes.length > 0) {
                checkedNodes = checkedNodes.concat(childCheckedNodes);
            }
        }
    }
    return checkedNodes;
}

function fixNodesStyle(treeView: kendo.ui.TreeView, items: kendo.data.ObservableArray | undefined) {
    items?.forEach((item: kendo.data.ObservableObject) => {
        if ('hasChildren' in item && item.hasChildren) {
            const childItems = ('items' in item ? item.items : []) as kendo.data.ObservableArray | undefined;
            fixNodesStyle(treeView, childItems);
        }
        else {
            treeView.findByUid(item.uid)?.find('.k-checkbox-wrapper').addClass('k-checkbox-wrapper-last-fix');
        }
    });
}

window.fixTreeView = fixTreeView;
window.getCheckedNodes = getCheckedNodes;
window.toggleTree = toggleTree;
window.getCheckedItems = getCheckedItems;
